<template>
  <v-window>
    <install-app></install-app>
    <v-content :class="{'landscape': isLandscape(), 'portrait': !isLandscape(), 'large': isLarge(),
                      'xs': $vuetify.breakpoint.xs, 'sm': $vuetify.breakpoint.sm,
                      'md': $vuetify.breakpoint.md, 'lg': $vuetify.breakpoint.lg,
                      'xl': $vuetify.breakpoint.xl}">

      <v-toolbar class="primary"
                 app
                 dark
                 dense
                 flat
                 :scroll-threshold="height"
                 scroll-off-screen
                 inverted-scroll
                 :height="toolbarHeight"
                 style="z-index:10">

        <div class="hidden-md-and-up text-xs-center"
             style="width:100%">
          <v-layout row
                    wrap>
            <v-flex xs12>
              <router-link to="/">
                <v-img src="/image/logo_bg_white.png"
                       width="200px"
                       height="40px"
                       class="mx-auto">
                </v-img>
              </router-link>
            </v-flex>
          </v-layout>

          <v-toolbar-items class="menuOptions text-xs-center ">
            <v-layout row
                      wrap
                      class="py-2">
              <v-flex xs12>
                <v-btn flat
                       small
                       :to="{path:$t('urlLogin')}"
                       class="font-weight-bold text-shadow">{{ $t('site.menu.login') }}</v-btn>
                <v-btn flat
                       small
                       :to="{path:$t('urlRegister')}"
                       class="font-weight-bold text-shadow">{{ $t('site.menu.signup') }}</v-btn>
              </v-flex>
            </v-layout>
          </v-toolbar-items>

          <v-layout row
                    wrap
                    class="pt-1">
            <v-flex xs12>
              <v-btn color="accent"
                     round
                     :to="{path:$t('urlParkingPage')}"
                     class="font-weight-bold text-shadow initialize"
                     v-html="$t('site.menu.seeParking')"></v-btn>
            </v-flex>
          </v-layout>
        </div>

        <v-layout class="hidden-sm-and-down wrap"
                  row>
          <v-toolbar-title>
            <router-link to="/">
              <v-img src="/image/logo_bg_white.png"
                     width="200px"
                     height="40px">
              </v-img>
            </router-link>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-toolbar-items class="menuOptions align-center">
            <v-btn color="accent"
                   round
                   :to="{path:$t('urlParkingPage')}"
                   class="font-weight-bold text-shadow mr-2 initialize"
                   v-html="$t('site.menu.seeParking')"></v-btn>

            <city-selector></city-selector>

            <change-language-dropdown onlyText
                                      class="px-2"
                                      color="white"></change-language-dropdown>

            <v-btn flat
                   :to="{path:$t('urlLogin')}"
                   class="bold text-shadow">{{ $t('site.menu.login') }}</v-btn>
            <v-btn flat
                   :to="{path:$t('urlRegister')}"
                   class="bold text-shadow">{{ $t('site.menu.signup') }}</v-btn>
          </v-toolbar-items>
        </v-layout>
      </v-toolbar>

      <v-toolbar color="transparent"
                 absolute
                 dark
                 :height="toolbarHeight"
                 flat>

        <div class="hidden-md-and-up"
             style="width:100%">

          <v-toolbar-items class="menuOptions justify-center ">
            <v-btn flat
                   :to="{path:$t('urlLogin')}"
                   class="bold px-2">
              <label class="secondary px-3 py-1 text-shadow"
                     style="cursor:inherit">
                {{ $t('site.menu.login') }}
              </label>
            </v-btn>
            <v-btn flat
                   :to="{path:$t('urlRegister')}"
                   class="bold px-2">
              <label class="secondary px-3 py-1 text-shadow"
                     style="cursor:inherit">{{ $t('site.menu.signup') }}
              </label>
            </v-btn>
          </v-toolbar-items>

          <v-layout row
                    wrap>
            <v-flex xs12>
              <!-- <img src="/image/logo_bg_white.png"
               width="80%"
               height="auto"
               class="mx-auto" /> -->
              <v-flex xs12>
                <router-link to="/">
                  <v-img src="/image/logo_bg_white.png"
                         width="200px"
                         height="40px"
                         class="mx-auto my-3">
                  </v-img>
                </router-link>
              </v-flex>

            </v-flex>
          </v-layout>
        </div>

        <v-layout class="hidden-sm-and-down wrap"
                  row>
          <v-toolbar-title>
            <router-link to="/">
              <v-img src="/image/logo_bg_white.png"
                     width="200px"
                     height="40px">
              </v-img>
            </router-link>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-toolbar-items class="menuOptions align-center">
            <city-selector></city-selector>

            <change-language-dropdown onlyText
                                      class="px-2"
                                      color="white"></change-language-dropdown>

            <v-btn flat
                   :to="{path:$t('urlLogin')}"
                   class="bold px-2">
              <label class="primary px-3 py-1 text-shadow"
                     style="cursor:inherit">
                {{ $t('site.menu.login') }}
              </label>
            </v-btn>
            <v-btn flat
                   :to="{path:$t('urlRegister')}"
                   class="bold px-2">
              <label class="accent px-3 py-1 text-shadow"
                     style="cursor:inherit">{{ $t('site.menu.signup') }}
              </label>
            </v-btn>
          </v-toolbar-items>
        </v-layout>
      </v-toolbar>

      <router-view></router-view>

      <wsp-footer></wsp-footer>
    </v-content>
  </v-window>
</template>

<script>
import WspFooter from '@/components/commons/WspFooter';
import InstallApp from '@/components/commons/InstallApp';
import ChangeLanguageDropdown from '@/components/commons/ChangeLanguageDropdown';
import CitySelector from '@/components/public/CitySelector';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import _ from 'lodash';

const HIDDEN_TOOLBAR = 48;

export default {
  name: 'PublicLayout',
  components: {
    [WspFooter.name]: WspFooter,
    [InstallApp.name]: InstallApp,
    [ChangeLanguageDropdown.name]: ChangeLanguageDropdown,
    [CitySelector.name]: CitySelector
  },
  computed: {
    toolbarHeight() {
      return this.$vuetify.breakpoint.smAndDown ? '150' : null;
    }
  },
  data() {
    return {
      height: 0
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = vm.$i18n.t(to.meta.i18nTitle);
    });
  },
  created() {
    EventBus.$on(keys.eventShowToolbar, this.showSecondToolbar);
    EventBus.$on(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  destroyed() {
    EventBus.$off(keys.eventShowToolbar, this.showSecondToolbar);
    EventBus.$off(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  methods: {
    showSecondToolbar(params) {
      this.height = params.offset - HIDDEN_TOOLBAR;
    },
    isLandscape() {
      return this.$vuetify.breakpoint.height < this.$vuetify.breakpoint.width;
    },
    isLarge() {
      return this.$vuetify.breakpoint.height > 650;
    },
    changeLanguage: function(params) {
      this.$router.replace(this.$i18n.t(this.$route.meta.i18nUrlLabel, this.$route.params));

      _.each(this.items, it => {
        it.pathName = this.$i18n.t(it.i18nUrl);
      });
    }
  }
};
</script>

<style lang="scss">
@import '~@/assets/css/public.scss';
</style>
